import { stripMarkdownForHighlightSnippet } from "~shared/agentHighlightSnippet.js";

/** Select/highlight server-applied prose once Yjs sync delivers inserted marks. */
export function dispatchAppliedManuscriptChangeHighlight(
  documentId: string,
  previewAfter?: string | null,
): void {
  const normalizedDocumentId = String(documentId ?? "").trim();
  const highlightSnippet = stripMarkdownForHighlightSnippet(
    String(previewAfter ?? ""),
  );
  if (!normalizedDocumentId || !highlightSnippet) return;

  window.dispatchEvent(new CustomEvent("sudo-agent-highlight-edit", {
    detail: {
      documentId: normalizedDocumentId,
      highlightSnippet,
    },
  }));
}
